import { Trigger } from "@radix-ui/react-tooltip"


export const TooltipTrigger = ({
    ...props
}: React.ComponentProps<typeof Trigger>) => {
    return <Trigger data-slot="tooltip-trigger" {...props} />
}